import { checkTrackJSAvailable } from '../logError';
import { getTrackJs } from '../window';

const logInfo = (message: string): void => {
  const trackJs = getTrackJs();

  if (checkTrackJSAvailable(trackJs)) {
    trackJs.console.info(message);
  } else {
    // eslint-disable-next-line no-console
    console.info(message);
  }
};

export default logInfo;
